module.exports = __webpack_public_path__ + "88730ab75ad003dcb67b068a7374c595.png";